import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { SigninService } from 'src/app/authentification/signin/signin.service';
import { User } from 'src/app/authentification/signin/credentials';

@Component({
  selector: 'app-stop-poi-excel',
  templateUrl: './stop-poi-excel.component.html',
  styleUrls: ['./stop-poi-excel.component.css'],
})
export class StopPoiExcelComponent implements OnInit, OnDestroy {
  excelData: any[] = [];
  excelData$: Subscription;
  dailyStop$: Subscription;
  isByVehicule$: Subscription;
  current: string = '';
  public currentUser: User = new User();
  currentSheet: number = 0;
  sheetNames: string[] = [];
  dailyStop: boolean = false;
  isByVehicule: boolean = true;
  
  processedSheets: Map<number, any[]> = new Map();
  filteredDataCache: Map<number, any[]> = new Map();
  headerRowIndexCache: Map<number, number> = new Map();
  reportTypeCache: Map<number, string> = new Map();

  private readonly COORDINATE_COLUMNS = ['Coordonnées', 'coordonnées', 'COORDONNEES', 'Coordonnees'];
  private readonly DURATION_COLUMNS = ['Temps d\'arrêt', 'T.A', 'Dépassement', 'T.A (min)'];
private readonly DAY_FRACTION_DURATION_COLUMNS = ['Temps d\'arrêt', 'Dépassement'];


  constructor(
    private importExportService: NewImportExportService,
    private authService: SigninService
  ) {
    const storedUser = localStorage.getItem('currentUser');
    this.currentUser = storedUser ? JSON.parse(storedUser) : {};
  }

  ngOnInit(): void {
    this.fetchDailyStopFlag();
    this.fetchIsByVehicule();
    this.fetchDataAndProcess();
    this.fetchUser();

      setTimeout(() => {
    this.debugExcelData();
  }, 1000);
  }

  ngOnDestroy(): void {
    if (this.excelData$) {
      this.excelData$.unsubscribe();
    }
    if (this.dailyStop$) {
      this.dailyStop$.unsubscribe();
    }
    if (this.isByVehicule$) {
      this.isByVehicule$.unsubscribe();
    }
    this.importExportService.setExcelData(null);
    this.importExportService.setCurentRapport(null);
    this.importExportService.setPdfToBePrinted(null);
    this.importExportService.setExcelToBeProcessed(null);
    this.processedSheets.clear();
    this.filteredDataCache.clear();
    this.headerRowIndexCache.clear();
    this.reportTypeCache.clear();
  }

  isDayFractionDurationColumn(header: string): boolean {
  if (!header) return false;
  return this.DAY_FRACTION_DURATION_COLUMNS.some(col => 
    header.trim().toLowerCase() === col.toLowerCase()
  );
}

  fetchDailyStopFlag(): void {
    this.dailyStop$ = this.importExportService.isDailyStop().subscribe((d) => {
      this.dailyStop = d;
    });
  }

  fetchIsByVehicule(): void {
    this.isByVehicule$ = this.importExportService.isByVehicule().subscribe((value) => {
      this.isByVehicule = value;
    });
  }

  fetchUser(): void {
    this.current = this.authService.getCurrentUser().displayName;
  }

  private normalizeExcelSheets(data: any[] | null): any[] {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    if (Array.isArray(data[0])) {
      return [{ sheetName: this.getSingleSheetName(data), data: data }];
    }

    if (data[0] && typeof data[0] === 'object' && 'data' in data[0]) {
      return data;
    }

    return [{ sheetName: this.getSingleSheetName(data), data: data }];
  }

  private getSingleSheetName(data: any[] | null): string {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return 'Feuille 1';
    }

    const candidate = data[0];
    if (candidate && typeof candidate === 'object' && 'sheetName' in candidate && candidate.sheetName) {
      return candidate.sheetName;
    }

    return 'Feuille 1';
  }

  fetchDataAndProcess(): void {
  this.excelData$ = combineLatest([
    this.importExportService.getExcelData(),
    this.importExportService.isDailyStop(),
    this.importExportService.isByVehicule(),
  ]).subscribe(([data, dailyStop, isByVehicule]) => {
    this.dailyStop = dailyStop;
    this.isByVehicule = isByVehicule;

    const normalizedData = this.normalizeExcelSheets(data as any[] | null);
    if (normalizedData.length > 0) {
      this.excelData = normalizedData;
      this.sheetNames = this.excelData.map((sheet) => sheet.sheetName || 'Feuille 1');
      this.currentSheet = 0;
      this.clearAllCaches();
    }
  });
}
  clearAllCaches(): void {
    this.processedSheets.clear();
    this.filteredDataCache.clear();
    this.headerRowIndexCache.clear();
    this.reportTypeCache.clear();
  }

  selectSheet(index: number): void {
    if (this.currentSheet === index) {
      // Si c'est la même feuille, recharger les données pour rafraîchir
      this.processedSheets.delete(index);
      this.filteredDataCache.delete(index);
      this.headerRowIndexCache.delete(index);
      this.reportTypeCache.delete(index);
    }
    this.currentSheet = index;
  }

  fillEmptyCells(row: any[], columnCount: number): any[] {
    while (row.length < columnCount) {
      row.push('');
    }
    return row;
  }

  private detectReportTypeAndHeader(sheetData: any[]): { type: string, headerIndex: number } {
    if (!sheetData || sheetData.length === 0) {
      return { type: 'unknown', headerIndex: 3 };
    }

    if (this.dailyStop) {
      const dailyIdx = sheetData.findIndex(
        (row: any[]) =>
          Array.isArray(row) &&
          row.some(
            (cell: any) =>
              cell !== null &&
              cell !== undefined &&
              cell.toString().trim() === 'Véhicule'
          ) &&
          row.some(
            (cell: any) =>
              cell !== null &&
              cell !== undefined &&
              cell.toString().trim() === 'Date début'
          )
      );
      if (dailyIdx >= 0) {
        return { type: 'daily', headerIndex: dailyIdx };
      }
    }

    if (!this.isByVehicule) {
      const groupIdx = sheetData.findIndex(
        (row: any[]) =>
          Array.isArray(row) &&
          row.some(
            (cell: any) =>
              cell !== null &&
              cell !== undefined &&
              cell.toString().trim() === 'Véhicule'
          ) &&
          row.some(
            (cell: any) =>
              cell !== null &&
              cell !== undefined &&
              cell.toString().trim() === 'Chauffeur'
          )
      );
      if (groupIdx >= 0) {
        return { type: 'group', headerIndex: groupIdx };
      }
    }

    if (this.isByVehicule) {
      const vehicleIdx = sheetData.findIndex(
        (row: any[]) =>
          Array.isArray(row) &&
          row.some(
            (cell: any) =>
              cell !== null &&
              cell !== undefined &&
              cell.toString().trim() === 'Date début'
          )
      );
      if (vehicleIdx >= 0) {
        return { type: 'vehicle', headerIndex: vehicleIdx };
      }
    }

    const fallbackIdx = sheetData.findIndex(
      (row: any[]) =>
        Array.isArray(row) &&
        row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() === 'Date début'
        )
    );
    return { type: 'unknown', headerIndex: fallbackIdx >= 0 ? fallbackIdx : 3 };
  }

  private getHeaderRowIndex(sheetData: any[]): number {
    const result = this.detectReportTypeAndHeader(sheetData);
    if (this.currentSheet < this.excelData.length) {
      this.reportTypeCache.set(this.currentSheet, result.type);
    }
    return result.headerIndex;
  }

  getReportType(): string {
    if (this.reportTypeCache.has(this.currentSheet)) {
      return this.reportTypeCache.get(this.currentSheet) || 'unknown';
    }
    const sheetData = this.excelData[this.currentSheet]?.data || [];
    const result = this.detectReportTypeAndHeader(sheetData);
    this.reportTypeCache.set(this.currentSheet, result.type);
    return result.type;
  }

  isCoordinateColumn(header: string): boolean {
    if (!header) return false;
    return this.COORDINATE_COLUMNS.some(col => 
      header.trim().toLowerCase() === col.toLowerCase()
    );
  }

  isDurationColumn(header: string): boolean {
    if (!header) return false;
    return this.DURATION_COLUMNS.some(col => 
      header.trim().toLowerCase() === col.toLowerCase()
    );
  }

  // Convertir une lettre de colonne Excel en index (A=0, B=1, ...)
  columnLetterToIndex(letter: string): number {
    let index = 0;
    for (let i = 0; i < letter.length; i++) {
      index = index * 26 + (letter.charCodeAt(i) - 64);
    }
    return index - 1;
  }

  // Obtenir l'index de la colonne par son nom
 getColumnIndexByName(headers: any[], columnName: string): number {
  const index = headers.findIndex((h: any) => 
    h && h.toString().trim() === columnName
  );
  console.log(`Column "${columnName}" found at index:`, index);
  return index;
}

formatDurationAsDaysHMS(value: any): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (typeof value === 'string' && value.startsWith('=')) {
    return value;
  }

  const decimalDays = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(decimalDays)) {
    return value?.toString() || '';
  }

  const totalSeconds = Math.round(decimalDays * 24 * 60 * 60);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

private getCellValueSafe(allData: any[], rowIdx: number, colIdx: number): number {
  if (!allData[rowIdx] || allData[rowIdx][colIdx] === undefined) return NaN;
  let val = allData[rowIdx][colIdx];
  if (typeof val === 'string' && val.startsWith('=')) {
    val = this.evaluateExcelFormula(val, allData[rowIdx], allData, 0, rowIdx);
  }
  const num = parseFloat(val);
  return isNaN(num) ? NaN : num;
}

evaluateExcelFormula(value: any, rowData: any[], allData: any[], headerRowIndex: number, rowIndex: number): any {
  if (typeof value !== 'string' || !value.startsWith('=')) {
    return value;
  }

  try {
    const formula = value.trim();

    // --- SUM ---
    if (formula.includes('SUM(')) {
      const match = formula.match(/SUM\(([A-Z]+)(\d+):([A-Z]+)(\d+)\)/);
      if (match) {
        const startRow = parseInt(match[2]);
        const endRow = parseInt(match[4]);
        const colLetter = match[1];
        const colIndex = this.columnLetterToIndex(colLetter);
        
        let sum = 0;
        for (let i = startRow; i <= endRow; i++) {
          const rowIdx = i - 1;
          if (allData[rowIdx] && allData[rowIdx][colIndex] !== undefined) {
            const val = parseFloat(allData[rowIdx][colIndex]);
            if (!isNaN(val)) sum += val;
          }
        }
        
        if (formula.includes('/(24*60)')) return parseFloat((sum / (24 * 60)).toFixed(6));
        if (formula.includes('/60')) return parseFloat((sum / 60).toFixed(6));
        if (formula.includes('/24')) return parseFloat((sum / 24).toFixed(6));
        return sum;
      }
      return value;
    }

    // =E6-(5/(24*60))  ← C'EST CELLE DANS TON FICHIER EXCEL
    const subConstDivMatch = formula.match(/=([A-Z]+)(\d+)-\((\d+(?:\.\d+)?)\/\(24\*60\)\)/);
    if (subConstDivMatch) {
      const colLetter = subConstDivMatch[1];
      const rowNum = parseInt(subConstDivMatch[2]);
      const subtract = parseFloat(subConstDivMatch[3]) / (24 * 60);
      const colIndex = this.columnLetterToIndex(colLetter);
      const rowIdx = rowNum - 1;
      const val = this.getCellValueSafe(allData, rowIdx, colIndex);
      if (!isNaN(val)) {
        return parseFloat((val - subtract).toFixed(6));
      }
      return value;
    }

    // =E6-5/(24*60) (sans parenthèses autour de la fraction)
    const subConstDivMatch2 = formula.match(/=([A-Z]+)(\d+)-(\d+(?:\.\d+)?)\/\(24\*60\)/);
    if (subConstDivMatch2) {
      const colLetter = subConstDivMatch2[1];
      const rowNum = parseInt(subConstDivMatch2[2]);
      const subtract = parseFloat(subConstDivMatch2[3]) / (24 * 60);
      const colIndex = this.columnLetterToIndex(colLetter);
      const rowIdx = rowNum - 1;
      const val = this.getCellValueSafe(allData, rowIdx, colIndex);
      if (!isNaN(val)) {
        return parseFloat((val - subtract).toFixed(6));
      }
      return value;
    }

    // =E6-(5/60)
    const subConstDiv60Match = formula.match(/=([A-Z]+)(\d+)-\((\d+(?:\.\d+)?)\/60\)/);
    if (subConstDiv60Match) {
      const colLetter = subConstDiv60Match[1];
      const rowNum = parseInt(subConstDiv60Match[2]);
      const subtract = parseFloat(subConstDiv60Match[3]) / 60;
      const colIndex = this.columnLetterToIndex(colLetter);
      const rowIdx = rowNum - 1;
      const val = this.getCellValueSafe(allData, rowIdx, colIndex);
      if (!isNaN(val)) {
        return parseFloat((val - subtract).toFixed(6));
      }
      return value;
    }

    // =F6/(24*60) ou =F6/60
    const simpleDivMatch = formula.match(/=\(?([A-Z]+)(\d+)\)?\/\(?(\d+(?:\*\d+)?)\)?/);
    if (simpleDivMatch) {
      const colLetter = simpleDivMatch[1];
      const rowNum = parseInt(simpleDivMatch[2]);
      const divisorStr = simpleDivMatch[3];
      const divisor = divisorStr.includes('*') ? eval(divisorStr) : parseInt(divisorStr);
      const colIndex = this.columnLetterToIndex(colLetter);
      const rowIdx = rowNum - 1;
      const val = this.getCellValueSafe(allData, rowIdx, colIndex);
      if (!isNaN(val) && divisor > 0) {
        return parseFloat((val / divisor).toFixed(6));
      }
      return value;
    }

    // =(F6 - 5)/(24*60) ou =(F6 - 5)/60
    const subDivMatch = formula.match(/=\(([A-Z]+)(\d+)\s*-\s*(\d+(?:\.\d+)?)\)\/\(?(\d+(?:\*\d+)?)\)?/);
    if (subDivMatch) {
      const colLetter = subDivMatch[1];
      const rowNum = parseInt(subDivMatch[2]);
      const subtract = parseFloat(subDivMatch[3]);
      const divisorStr = subDivMatch[4];
      const divisor = divisorStr.includes('*') ? eval(divisorStr) : parseInt(divisorStr);
      const colIndex = this.columnLetterToIndex(colLetter);
      const rowIdx = rowNum - 1;
      const val = this.getCellValueSafe(allData, rowIdx, colIndex);
      if (!isNaN(val) && divisor > 0) {
        return parseFloat(((val - subtract) / divisor).toFixed(6));
      }
      return value;
    }

    // =E6-F6 (soustraction entre 2 cellules)
    const subCellMatch = formula.match(/=([A-Z]+)(\d+)-([A-Z]+)(\d+)/);
    if (subCellMatch) {
      const col1 = this.columnLetterToIndex(subCellMatch[1]);
      const row1 = parseInt(subCellMatch[2]) - 1;
      const col2 = this.columnLetterToIndex(subCellMatch[3]);
      const row2 = parseInt(subCellMatch[4]) - 1;
      const val1 = this.getCellValueSafe(allData, row1, col1);
      const val2 = this.getCellValueSafe(allData, row2, col2);
      if (!isNaN(val1) && !isNaN(val2)) {
        return parseFloat((val1 - val2).toFixed(6));
      }
      return value;
    }

    // =E6-5 (soustraction d'un nombre)
    const subNumMatch = formula.match(/=([A-Z]+)(\d+)-(\d+(?:\.\d+)?)/);
    if (subNumMatch) {
      const col = this.columnLetterToIndex(subNumMatch[1]);
      const row = parseInt(subNumMatch[2]) - 1;
      const num = parseFloat(subNumMatch[3]);
      const val = this.getCellValueSafe(allData, row, col);
      if (!isNaN(val)) {
        return parseFloat((val - num).toFixed(6));
      }
      return value;
    }

    return value;
  } catch (e) {
    console.warn('Error evaluating formula:', value, e);
    return value;
  }
}
 
  shouldHideColumn(header: string): boolean {
    return false;
  }

  getVisibleHeaders(): any[] {
    return this.getHeaders();
  }

  getVisibleColumnIndices(): number[] {
    const headers = this.getHeaders();
    return headers.map((_, index) => index);
  }

  formatDuration(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    
    if (typeof value === 'string' && value.startsWith('=')) {
      return value;
    }
    
    let num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) {
      return value?.toString() || '';
    }
    
    return num.toFixed(2);
  }

  extractCoordinates(value: any): { lat: string, lng: string } | null {
    if (!value || value === '') return null;
    
    const str = value.toString().trim();
    const parts = str.split(';');
    if (parts.length === 2) {
      const lat = parseFloat(parts[0]);
      const lng = parseFloat(parts[1]);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { lat: lat.toString(), lng: lng.toString() };
      }
    }
    return null;
  }

  getGoogleMapsLink(coordinates: string): string {
    if (!coordinates) return '#';
    const coords = this.extractCoordinates(coordinates);
    if (coords) {
      return `http://maps.google.com/?q=${coords.lat},${coords.lng}`;
    }
    return '#';
  }

  hasValidCoordinates(value: any): boolean {
    return this.extractCoordinates(value) !== null;
  }

  getTitleInfo(): { title: string, info: string } {
    const sheetData = this.getActiveSheetData();
    if (sheetData.length === 0) {
      return { title: '', info: '' };
    }
    
    const titleRow = sheetData[0] || [];
    const reportType = this.getReportType();
    
    if (reportType === 'daily') {
      return {
        title: titleRow[2] || 'Rapport journalier des arrêts par POI',
        info: titleRow[4] || ''
      };
    }
    
    if (reportType === 'group') {
      const infoCell = titleRow[4] || '';
      return {
        title: titleRow[2] || 'Liste des arrêts par POI',
        info: infoCell
      };
    }
    
    if (reportType === 'vehicle') {
      const infoCell = titleRow[4] || '';
      return {
        title: titleRow[2] || 'Liste des arrêts par POI',
        info: infoCell
      };
    }
    
    return {
      title: titleRow[2] || titleRow[1] || 'Liste des arrêts par POI',
      info: titleRow[4] || titleRow[3] || ''
    };
  }

 

  getActiveSheetData(): any[] {
  if (this.currentSheet >= this.excelData.length) {
    return [];
  }

  // Si la feuille est déjà traitée, retourner le résultat en cache
  if (this.processedSheets.has(this.currentSheet)) {
    return this.processedSheets.get(this.currentSheet) || [];
  }

  const sheetData = this.excelData[this.currentSheet]?.data || [];

  if (sheetData.length === 0) {
    return [];
  }

  // Déterminer l'index de la ligne des headers
  const headerRowIndex = this.getHeaderRowIndex(sheetData);

  // Déterminer le nombre maximum de colonnes
  const columnCount = Math.max(
    ...sheetData.map((row: any[]) => row?.length || 0)
  );

  if (columnCount === 0) {
    return [];
  }

  /**
   * COPIE PROFONDE
   *
   * On ne modifie jamais excelData directement.
   * Chaque ligne est copiée dans un nouveau tableau.
   */
  const result = sheetData.map((row: any[]) => {
    const newRow = row ? [...row] : [];

    // Compléter les cellules manquantes
    while (newRow.length < columnCount) {
      newRow.push('');
    }

    return newRow;
  });

  /**
   * IMPORTANT :
   *
   * On ne réévalue plus les formules Excel ici.
   *
   * Avant, evaluateExcelFormula() pouvait modifier la valeur
   * d'une cellule comme "Dépassement" en utilisant une autre
   * cellule, ce qui pouvait provoquer :
   *
   * Temps d'arrêt = Dépassement
   *
   * On conserve donc exactement les données reçues depuis Excel.
   */

  // Conserver l'index de la ligne des headers
  (result as any).headerRowIndex = headerRowIndex;

  // Mettre en cache le résultat
  this.processedSheets.set(this.currentSheet, result);
  this.headerRowIndexCache.set(this.currentSheet, headerRowIndex);

  return result;
}


isCoordsColumn(header: string): boolean {
  return header === 'Coordonnées' || header === 'LatLng';
}

hasAnyData(): boolean {
  if (!this.excelData || this.excelData.length === 0) {
    return false;
  }
  return this.excelData.some(sheet => sheet?.data && sheet.data.length > 0);
}

debugExcelData(): void {
  const sheetData = this.getActiveSheetData();
  const headers = this.getHeaders();
  const tempArretIdx = this.getColumnIndexByName(headers, 'Temps d\'arrêt');
  const depassementIdx = this.getColumnIndexByName(headers, 'Dépassement');

  console.log('=== VERIF COLONNES ===');
  console.log('Index Temps d\'arrêt:', tempArretIdx, '| Index Dépassement:', depassementIdx);

  const filtered = this.getFilteredData();
  filtered.slice(0, 10).forEach((row, i) => {
    console.log(`Row ${i} -> T.A:`, row[tempArretIdx], '| Dépassement:', row[depassementIdx], '| raw row:', row);
  });
}

  

  getFilteredData(): any[] {
    if (this.filteredDataCache.has(this.currentSheet)) {
      return this.filteredDataCache.get(this.currentSheet) || [];
    }

    const activeData = this.getActiveSheetData();
    const headerRowIndex = this.headerRowIndexCache.get(this.currentSheet) ?? 3;

    if (activeData.length === 0) return [];

    const filtered = activeData
      .slice(headerRowIndex + 1)
      .filter((row: any[]) =>
        row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() !== ''
        )
      );

    this.filteredDataCache.set(this.currentSheet, filtered);
    return filtered;
  }

  isTotalRow(row: any[]): boolean {
    if (!row || row.length === 0) return false;
    return row.some((cell: any) => 
      cell && typeof cell === 'string' && 
      (cell.toLowerCase().includes('total') && !cell.toLowerCase().includes('total (heure)'))
    );
  }

  isTotalHoursRow(row: any[]): boolean {
    if (!row || row.length === 0) return false;
    return row.some((cell: any) => 
      cell && typeof cell === 'string' && cell.toLowerCase().includes('total (heure)')
    );
  }

  getRow(rowIndex: number): any[] {
    const sheetData = this.getActiveSheetData();
    return sheetData[rowIndex] || [];
  }

  getColumnCount(): number {
    const sheetData = this.getActiveSheetData();
    return sheetData[0]?.length || 0;
  }

  getHeaders(): any[] {
  const sheetData = this.getActiveSheetData();
  const headerRowIndex = this.headerRowIndexCache.get(this.currentSheet) ?? 3;
  const headers = sheetData[headerRowIndex] || [];
  console.log('Headers found:', headers);
  return headers;
}

  getRowClass(row: any[]): string {
    if (this.isTotalHoursRow(row)) {
      return 'total-hours-row';
    }
    if (this.isTotalRow(row)) {
      return 'total-row';
    }
    return '';
  }

  getCellValue(row: any[], index: number, header: string): string {
    if (!row || index >= row.length) {
      return '';
    }
    
    const value = row[index];
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Si c'est une ligne de total, formater avec 2 décimales
    if (this.isTotalRow(row) || this.isTotalHoursRow(row)) {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        return num.toFixed(2);
      }
      return value?.toString() || '';
    }

    // Si c'est une colonne de durée (T.A (min) uniquement)
    if (header === 'T.A (min)') {
      return this.formatDuration(value);
    }

    return value?.toString() || '';
  }

  isMapLink(header: string, value: any): boolean {
    return header === 'Coordonnées' && this.hasValidCoordinates(value);
  }

  // Forcer le rafraîchissement de la feuille actuelle
  refreshCurrentSheet(): void {
    const index = this.currentSheet;
    this.processedSheets.delete(index);
    this.filteredDataCache.delete(index);
    this.headerRowIndexCache.delete(index);
    this.reportTypeCache.delete(index);
  }
}